import { Fragment, useState } from 'react';
import styles from './paginator.module.css'
export default function Paginator (props: {totalRows: number, setPage: any, page: number}) {
	const {totalRows} = props;
	const pageSize = process.env.NEXT_PUBLIC_PAGE_SIZE ? Number(process.env.NEXT_PUBLIC_PAGE_SIZE) : 50;
	return (
			<div className={styles.container}>
			<button 
				className={styles.paginationBtn}
				style={{visibility: props.page === 1 ? 'hidden' : 'visible'}}
				disabled={props.page === 1}
				onClick={() => {
				window.scrollTo(0,0);
				props.setPage(props.page - 1);}
				}><Fragment>&lt;&lt; </Fragment></button>
			<div>
				{
					Math.round(totalRows / pageSize) > 0 ? 
					<div style={{fontWeight: 600, fontSize: '14px'}}>Side {props.page} av {Math.round(totalRows / pageSize)}</div> : 
					<></>
				}
				<div style={{marginTop: '8px'}}>{
					Array.from(Array(Math.round(totalRows / pageSize)).keys())
					.map((r,index) => {
						return (
						<div key={`page${index+1}`} className={`${styles.pageBtn} ${props.page == (r+1) ? styles.pageBtnSelected : ''}`}
						onClick={(e) => {
							window.scrollTo(0,0);
							props.setPage(Number(e.currentTarget.innerText));
						}}>{(r+1)}</div>)
					})}
				</div>
			</div>							
			<button 
				style={{visibility: props.page === Math.round(totalRows / pageSize) ? 'hidden' : 'visible'}}
				className={styles.paginationBtn}
				disabled={props.page === Math.round(totalRows / pageSize)}
				onClick={() => {window.scrollTo(0,0);props.setPage(props.page + 1);
			}}><Fragment>&gt;&gt;</Fragment></button>	
			</div>

	)
}